module.exports = __webpack_public_path__ + "img/14.345b6df4.png";